import {createMediaSignals} from '@pexip/media';
import {createSignal} from '@pexip/signal';

export const pushToTalkSignal = createSignal<boolean>({
    name: 'media:unmute:actions',
});

export const mediaSignals = createMediaSignals(
    [
        'onStatusChanged',
        'onDevicesChanged',
        'onStreamTrackEnabled',
        'onStreamTrackEnded',
        'onStreamTrackMuted',
        'onStreamTrackUnmuted',
        'onAudioMuteStateChanged',
        'onVideoMuteStateChanged',
    ],
    'infinity-connect',
);
